
import React from 'react';
import { Shield, Users, Eye, TrendingUp } from 'lucide-react';

const WhatRedFlagsDoes = () => {
  const features = [
    {
      icon: <Eye className="w-6 h-6" />,
      title: "AI Career Coaching",
      description: "Personalised career advice based on your background the company you are considering joining."
    },
    {
      icon: <Shield className="w-6 h-6" />,
      title: "Financial & Investment Health Check",
      description: "We monitor and review company stability based on profitability and investment rounds for you."
    },
    {
      icon: <Users className="w-6 h-6" />,
      title: "Employee Exit Reviews",
      description: "Discover from previous employees and recruiters the unbiased truth before joining a company."
    },
    {
      icon: <TrendingUp className="w-6 h-6" />,
      title: "Media Analysis",
      description: "Our AI's read and review all company media online to score and assess company perception and stability."
    }
  ];

  return (
    <section className="py-20 px-6 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="text-center mb-16 animate-fade-in">
          <h2 className="text-4xl font-bold mb-6 text-redflags-dark">
            What RedFlags does
          </h2>
          <p className="text-xl text-redflags-gray max-w-3xl mx-auto leading-relaxed">
            Empowering job seekers with transparency and insights to make informed career decisions. 
            Discover the truth about potential employers before you apply.
          </p>
        </div>

        {/* Features Grid - Fixed to always be 2x2 */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto">
          {features.map((feature, index) => (
            <div 
              key={index} 
              className="bg-white p-8 rounded-2xl shadow-sm border border-gray-100 hover:shadow-md transition-shadow duration-300 animate-slide-in" 
              style={{
                animationDelay: `${index * 0.1}s`
              }}
            >
              <div className="w-14 h-14 rounded-full bg-redflags-red/10 flex items-center justify-center text-redflags-red mb-6">
                {feature.icon}
              </div>
              <h3 className="font-semibold text-xl mb-4 text-redflags-dark">
                {feature.title}
              </h3>
              <p className="text-redflags-gray leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="text-center mt-16">
          <div className="bg-white rounded-2xl p-8 shadow-sm border border-gray-100 max-w-2xl mx-auto">
            <h3 className="text-2xl font-bold mb-4 text-redflags-dark">
              Ready to take control of your career?
            </h3>
            <p className="text-redflags-gray mb-6">Join thousands of job seekers making smarter career decisions with RedFlags.</p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <button className="bg-redflags-red hover:bg-redflags-red/90 text-white px-6 py-3 rounded-lg font-medium transition-colors">
                Search Companies
              </button>
              <button className="border border-redflags-red text-redflags-red hover:bg-redflags-red/5 px-6 py-3 rounded-lg font-medium transition-colors">
                Share Your Experience
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhatRedFlagsDoes;
